import axios from 'src/api/Api';
import {
    DELETE_ORDER_SUCCESS,
    DELETE_ORDER_FAILURE,
} from 'src/pages/orders/redux/actions';
import { put } from 'redux-saga/effects';
import { errorHandler } from 'src/errorHandler/errorHandler';
import { logUiErrorToBackend } from 'src/utils/logUiErrorToBackend';

export default function* deleteOrder(action) {
    
    const url = `/occ/v2/${localStorage.getItem('baseSiteId')}/orders/${
        action.payload
    }`;

    try {
        const result = yield axios
            .delete(url)
            .then((response) => response.data);
        yield put({ type: DELETE_ORDER_SUCCESS, payload: result });

        // if (result && result.statusCode === '10707') {
        //     let newOrderList = [...orderList];
        //     const deleteIndex = newOrderList.findIndex(
        //         (data) => data.myCaseRef === action.payload
        //     );
        //     if (deleteIndex >= 0) {
        //         newOrderList.splice(deleteIndex, 1);
        //         yield put({
        //             type: GET_ORDERS_LIST_DATA_SUCCESS,
        //             data: newOrderList,
        //         });
        //     }
        // }
    } catch (e) {
        logUiErrorToBackend(e, {
            apiEndPoint: url,
            requestPayload: action.payload
        });
        yield put({
            type: DELETE_ORDER_FAILURE,
            templateError: errorHandler('503'),
        });
    }
}
